var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDischarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25501 9.53671C1.31251 9.75253 1.53251 9.88202 1.74501 9.82362L7.15501 8.35097C7.36751 8.29257 7.49501 8.06913 7.43751 7.85331L6.19501 3.14336C6.13751 2.92754 5.91751 2.79804 5.70501 2.85644L3.77501 3.38457L4.39501 5.73828L2.85001 6.15722L2.23001 3.80351L0.297513 4.3291C0.0850136 4.3875 -0.0424863 4.61093 0.0150137 4.82675L1.25501 9.53671ZM9.60001 0C9.15751 0 8.80001 0.363086 8.80001 0.812499V9.0289L0.147514 11.4258C0.0400136 11.4562 -0.0224863 11.568 0.00751366 11.6746L0.322513 12.8502C0.352513 12.9594 0.462513 13.0228 0.567513 12.9924L10.41 10.2654C10.47 11.7838 11.69 13 13.2 13C14.7475 13 16 11.7279 16 10.1562V0H9.60001ZM13.2 11.375C12.5375 11.375 12 10.8291 12 10.1562C12 9.48339 12.5375 8.93749 13.2 8.93749C13.8625 8.93749 14.4 9.48339 14.4 10.1562C14.4 10.8291 13.8625 11.375 13.2 11.375Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDischarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discharge.a24ab177f5eec4efd85a61a3ac57e1ae.svg";